"use client";

import { useListV3EmbeddedWalletAccounts } from "@/gen/orval/webplatform-v3/endpoints/embedded-wallets/embedded-wallets.gen";
import { useEmbeddedWalletsEnabled } from "@/lib/hooks/flags/use-embedded-wallets-enabled";

export function useListEmbeddedWalletAccounts(enabled = true) {
  const ffEnabled = useEmbeddedWalletsEnabled();
  return useListV3EmbeddedWalletAccounts({ query: { enabled: (ffEnabled ?? false) && enabled } });
}
